import {
  IItem,
  ITextLengthValidatable,
} from "../items";
import { AbstractInputRuleAlert } from "./AbstractInputRuleAlert";

export class TextLengthAlert extends AbstractInputRuleAlert<IItem & ITextLengthValidatable> {
  constructor(itemSetId: number, item: IItem & ITextLengthValidatable) {
    super(itemSetId, item);
  }

  get itemName(): string {
    return this._detectedItem.getDisplayName();
  }

  get description(): string {
    return "文字数が"
      + this._detectedItem.lengthChecklength
      + "より大きくなっています。現在の文字数は"
      + this._detectedItem.getTextLength()
      + "です。";
  }
}
